module.exports = __webpack_public_path__ + "static/media/pokestat-login.26225e98.png";